import { Badge, Card, Container, Image, Tab, Tabs } from 'react-bootstrap';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import picFloor1 from './assets/floor_1.png';
import picFloor2 from './assets/floor_2.png';
import picFloor3 from './assets/floor_3.png';
import picFloor4 from './assets/floor_4.png';
import picInfo from './assets/info.png';

const floors = [
    {
        name: 'Этаж 1',
        pic: picFloor1,
        id: 1,
    },
    {
        name: 'Этаж 2',
        pic: picFloor2,
        id: 2,
    },
    {
        name: 'Этаж 3',
        pic: picFloor3,
        id: 3,
    },
    {
        name: 'Этаж 4',
        pic: picFloor4,
        id: 4,
    },
];

function useMainDataForRequest(requestNum, requests) {
    return useMemo(() => {
        if (!requests) return [];
        const request = [...requests.author, ...requests.participant].find((req) => +requestNum === +req.num);
        if (request) {
            return [request, request.nomination];
        }
        return [];
    }, [requestNum, requests]);
}

export function RequestRoomPage(props) {
    const requests = useSelector((state) => state.requests.requests);
    const { requestNum } = useParams();
    const [request, nomination] = useMainDataForRequest(requestNum, requests);
    return (
        <Container className="my-3 my-sm-5">
            {request ? (
                <>
                    <Card className="mx-auto mb-3">
                        <Card.Header>
                            <Card.Title className="mb-0">
                                Гримерка к заявке № {request.num}, {nomination.name}
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            {request.room ? (
                                <div>
                                    Ваша гримерка <Badge variant="info">{request.room.name}</Badge>
                                </div>
                            ) : (
                                <div>Вашей заявке не назначена гримерка.</div>
                            )}
                        </Card.Body>
                    </Card>
                    <Card className="mx-auto mb-3">
                        <Card.Header>
                            <Card.Title className="mb-0">Схема (ориентировочная)</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Tabs defaultActiveKey="1" id="room-map-tabs">
                                {floors.map((floor) => (
                                    <Tab title={floor.name} eventKey={floor.id} key={floor.id}>
                                        <Image src={floor.pic} fluid className="mt-3" />
                                    </Tab>
                                ))}
                            </Tabs>
                            <Image src={picInfo} fluid className="mt-3" />
                        </Card.Body>
                    </Card>
                    <Card className="mx-auto">
                        <Card.Header>
                            <Card.Title className="mb-0">Правила</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <ul>
                                <li>Верхнюю одежду сдавать в гардероб.</li>
                                <li>
                                    К своей гримерке вы можете добраться самостоятельно (смотрите схему), так и
                                    обратиться за помощью к волонтерам, которые будут встречать с утра на входе.
                                </li>
                                <li>
                                    Гримерка прикреплена к заявке только в день выступления. Если в другой день у вас
                                    нет выступлений, но вам необходимо переодеться, то можете использовать общую
                                    гримерку.
                                </li>
                                <li>
                                    К одной гримерке может быть прикреплено несколько команд, поэтому будьте внимательны
                                    друг к другу и к чужому крафту и косплею.
                                </li>
                                <li>
                                    Будьте аккуратны. Не разбрасывайте вещи и мусор по помещениям. Мусор собирайте в
                                    мусорные пакеты. Запрещено наносить какой-либо ущерб имуществу ДК (в том числе полу
                                    и стенам).
                                </li>
                                <li>
                                    За вещи в гримерных помещениях отвечаете вы сами. Ни организаторы фестиваля, ни
                                    администрация ДК за них ответственности не несут. Не оставляйте ценные вещи без
                                    присмотра. Сдавайте их в камеру хранения или в гардероб, либо носите с собой.
                                </li>
                                <li>
                                    Гримерки за кулисами (9 и 10) обычно не прикрепляются к какой-либо команде. Хотя бы
                                    одна из них всегда свободна и доступна всем желающим для возможности переодеться или
                                    подправить свой косплей во время выступлений. Самовольно занимать данные гримерки на
                                    длительное время запрещено.
                                </li>
                            </ul>
                        </Card.Body>
                    </Card>
                </>
            ) : (
                <h2 className="text-center">Нет такой заявки</h2>
            )}
        </Container>
    );
}
